import { render, staticRenderFns } from "./Figures.vue?vue&type=template&id=34bdc803&"
import script from "./Figures.vue?vue&type=script&lang=ts&"
export * from "./Figures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports